import { i18n } from "@lingui/core";
import { msg } from "@lingui/macro";
import { ErrorMessage } from "@stylingcv/utils";

/**
 * Error message descriptors - created at compile time with msg macro
 * and resolved at runtime with i18n._()
 */
const errorMessages = {
  [ErrorMessage.InvalidCredentials]: msg`It doesn't look like a user exists with the credentials you provided.`,
  [ErrorMessage.UserAlreadyExists]: msg`A user with this email address and/or username already exists.`,
  [ErrorMessage.SecretsNotFound]: msg`User does not have an associated 'secrets' record. Please report this issue on GitHub.`,
  [ErrorMessage.OAuthUser]: msg`This email address is associated with an OAuth account. Please sign in with your OAuth provider.`,
  [ErrorMessage.InvalidResetToken]: msg`It looks like the reset token you provided is invalid. Please try restarting the password reset process again.`,
  [ErrorMessage.InvalidVerificationToken]: msg`It looks like the verification token you provided is invalid. Please try restarting the verification process again.`,
  [ErrorMessage.EmailAlreadyVerified]: msg`It looks like your email address has already been verified.`,
  [ErrorMessage.TwoFactorNotEnabled]: msg`Two-factor authentication is not enabled for this account.`,
  [ErrorMessage.TwoFactorAlreadyEnabled]: msg`Two-factor authentication is already enabled for this account.`,
  [ErrorMessage.InvalidTwoFactorCode]: msg`It looks like the two-factor authentication code you provided is invalid. Please try again.`,
  [ErrorMessage.InvalidTwoFactorBackupCode]: msg`It looks like the backup code you provided is invalid or used. Please try again.`,
  [ErrorMessage.InvalidBrowserConnection]: msg`There was an error connecting to the browser. Please make sure 'chrome' is running and reachable.`,
  [ErrorMessage.ResumeSlugAlreadyExists]: msg`A resume with this slug already exists, please pick a different unique identifier.`,
  [ErrorMessage.ResumeNotFound]: msg`It looks like the resume you're looking for doesn't exist.`,
  [ErrorMessage.ResumeLocked]: msg`The resume you want to update is locked, please unlock if you wish to make any changes to it.`,
  [ErrorMessage.ResumePrinterError]: msg`Something went wrong while printing your resume. Please try again later or raise an issue on GitHub.`,
  [ErrorMessage.ResumePreviewError]: msg`Something went wrong while grabbing a preview your resume. Please try again later or raise an issue on GitHub.`,
  [ErrorMessage.SomethingWentWrong]: msg`Something went wrong while processing your request. Please try again later or raise an issue on GitHub.`,
} as const;

export const translateError = (error: ErrorMessage) => {
  const descriptor = errorMessages[error];
  if (descriptor) {
    return i18n._(descriptor);
  }
  return null;
};
